import React from "react";

const TripCard = props => {
  // const { title, description, distance, date } = props.trip;

  return <div></div>;
};

export default TripCard;
